import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseUser() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName) {
      enqueueSnackbar("لطفا اطلاعات کاربر را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getUserList = (myPC, search, callback, bool) => {
    let newMyPc = myPC;
    if (myPC.sortColumn == "FirstName") {
      newMyPc.sortColumn = "Name";
    }
    if (myPC.sortColumn == "LastName") {
      newMyPc.sortColumn = "Family";
    }
    MyAxios.get(`Admin_Users?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllUserList = (callback) => {
    let myPc = {
      // page: 1,
      pageCount: 1,
      sortColumn: "Name",
      sortOrder: "Asc",
    };
    MyAxios.get(`Admin_Users?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getUserByID = (id, callback) => {
    MyAxios.get(`Admin_Users/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateUser = (state, file, callback) => {
    const data = new FormData();
    if (file !== undefined) {
      data.append("file", file);
    }
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Users`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کاربر با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addUser = (state, callback) => {
    const data = new FormData();
    data.append("Mobile", state);
    MyAxios.post(`Admin_Users`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کاربر با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteUser = (id, callback) => {
    const data = new FormData();
    data.append("UserID", id);
    MyAxios.delete(`Admin_Users`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کاربر با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getUserList,
    getUserByID,
    validate,
    updateUser,
    deleteUser,
    addUser,
    getAllUserList,
  };
}
